import React from 'react';
import PropTypes from 'prop-types';
import { Route, Link, withRouter } from "react-router-dom";
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography';
import AddCircleIcon from '@material-ui/icons/AddCircle'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button'
import HelpIcon from '@material-ui/icons/Help'
import Answer from './answer'
import Paper from '@material-ui/core/Paper'
import ReactQuill from 'react-quill'

import 'react-quill/dist/quill.bubble.css'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const swal = withReactContent(Swal)


const singleanswerstyle = {
  margin:'5px',
  marginLeft : '20px'
}

const removebutton = {
  float: 'right'
}

const modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline','strike', 'blockquote'],
      [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
      ['clean']
    ],
  }

const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
  ]



export default class Question extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      answers : [],
      writing : false,
      pasting : false
    }
  }




  addAnswer = () => {
    let atmp = this.props.answers || []
    atmp.push({text :false , correct : false, active : true})
    this.props.modQuestion({...this.props,answers:atmp})
    this.setState({answers : atmp})
  }

  removeAnswer = (i) => {
    swal.fire({
      text : 'Antwort unwiederbringlich löschen?',
      confirmButtonText: 'Ja',
      showCancelButton: true,
      type : 'warning',
    }).then((data) => {
      if ('value' in data && data.value == true){
    let atmp = this.props.answers
    atmp.splice(i,1)
    this.props.modQuestion({...this.props,answers:atmp})
  }})
  }




  modAnswer = (newval,i) => {
    let answers = this.props.answers
    answers[i] =newval
    this.props.modQuestion({...this.props,answers : answers})
  }



  render () {
    const {index, active, text, modQuestion } = this.props
    return (
          <div className={'Frage'+(index+1)}> {(index+1)+'. Frage'} &nbsp; &nbsp;
            <FormControlLabel
                control={
                      <Checkbox
                        checked={active}
                        onClick={e => modQuestion({...this.props,active:!active})}
                      />
                }
                label="aktiv"
            />
            <CloseIcon style={removebutton} onClick={this.props.removeQuestion}/>
              <ReactQuill placeholder="Frage eingeben"
                  theme="bubble"
                  modules={modules}
                  formats={formats}
                  value={text}
                  bounds= {'.Frage'+(index+1)}
                  onFocus = {e => this.setState({writing : true})}
                  onBlur = {e => setTimeout(() => {this.setState({writing: false})},100)}
                  onChange={value => this.state.writing  && modQuestion({...this.props,text:value})}
              />
              {this.props.answers.map((a,i) =>
                <Paper   key={i} style={singleanswerstyle}>
                    <Answer {...a} index={i} modAnswer={newval => this.modAnswer(newval,i)} removeAnswer={j => this.removeAnswer(i)}/>
                </Paper>
               )}
              <Button onClick={this.addAnswer}>
              <AddCircleIcon />Antwort hinzufügen
              </Button>
          </div>

    )
  }


}
